import Axios from "axios";
import config from "../app.config";

export default {
    showCustomer,
    updateCustomerDomain,
    getCustomerLinked,
    searchCustomerLink,
}

async function showCustomer(email) {
    return await Axios.get(`${config.LOCAL_API_URL}/getCustomerInfo/` + email)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function searchCustomerLink(data){
    return await Axios.get(`${config.LOCAL_API_URL}/searchCustomerLink`,data)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function updateCustomerDomain(data) {
    return await Axios.put(`${config.LOCAL_API_URL}/updateCustomerDomain/` + data.email, data)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function getCustomerLinked() {
    return await Axios.get(`${config.LOCAL_API_URL}/getCustomerDomain`)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
